import audio from '../../../../assets/audio/kids-tracks/Text3.mp3';
import hint from '../../../../assets/images/games/zdar-kids-game/hints/4.webp';

export const step4vampireTalks = {
    id: 4,
    title: 'Upír',
    taskText: `
        <p>
            Ty jsi to dokázal! Opravdu to je upír. Já nikdy žádného nepotkal, takže bych na to sám nikdy nepřišel. 
            Jmenuje se Ulrich a kdysi tu byl správcem. Už když byl naživu, tak z něj lidi měli strach, 
            nechoval se k nim moc dobře. Proto tu po své smrti zůstal strašit. Už nějakou dobu čeká na vysvobození, 
            nikdo mu ale nedokázal pomoct. 
        </p>
        <p>   
            Ptal jsem se ho, jestli neví, proč se té hoře říká zelená a taky netuší. Nikdy se tam neodvážil jít, 
            protože je tam na něj moc sluníčka. Říkal ale, že ten most, na který koukáme, se jmenuje červený. 
            Myslí si, že to je kvůli tomu, že tu dřív číhal na lidi a pil jim krev. Teď už se ale nemusíme bát, krev už lidem nepije.
        </p>
        <p>
            Tak to nám moc nepomohl. Ale chce s námi oslavit to, že jsme ho osvobodili. 
            Co kdybychom se s ním proletěli támhle na konec té aleje? Jsou tam schody, u kterých jsem viděl něco podivného.
        </p>
    `,
    audio: audio,
    continueButtonText: 'Jsme u schodů',
    hints: [
        {
            image: hint,
        },
    ],
    points: false,
};
